import { callApi } from '@local_modules/generic/fetch'
import { fillString } from '@local_modules/generic/string-template'

export async function revokeToken (tokenSetInfo) {
  const urlEndpoint = '/api/connect-xero/:xeroTokenId/revoke-token'

  const url = fillString(urlEndpoint, {
    xeroTokenId: tokenSetInfo.appTokenId
  })

  const response = await callApi(url, null, {
    method: 'DELETE'
  })
  console.log('response', response)
}
